<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "performanceRuleInfo",
        key: "id",
        url: {
          list: "/admin/system/performanceRule/listUserPerformanceRule",
          del: "/admin/system/performanceRule",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
        },
      ],
      menus: [],
      query: {},
      filters: [
        {
          label: "标题",
          KeyEnter: this.search,
          name: "title",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "工程师名称",
          key: "userName",
          minWidth: 180,
          align: "center",
        },
        {
          title: "工单数量",
          key: "monthlyTargetCount",
          minWidth: 180,
          align: "center",
        },
        {
          title: "绩效薪资",
          minWidth: 180,
          align: "center",
          key: "performanceSalary",
        },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          handle: ["edit", "delete"],
        },
      ],
      monthlyTargetCount: null,
    };
  },
  created() {
    let query = (this.$route && this.$route.query) || {};
    console.log(query);
    this.query.customerId = query.kv;
    this.monthlyTargetCount = query.monthlyTargetCount;
  },
  methods: {
    toAdd() {
      $utils.url.push({
        name: "performance_admin_engineer",
        query: {
          action: "add",
          customerId: this.query.customerId,
          monthlyTargetCount: this.monthlyTargetCount,
        },
      });
    },
    handleEdit(currentRow) {
      console.log(currentRow);

      let kv = currentRow.id;
      $utils.url.push({
        name: "performance_admin_engineer",
        query: { action: "edit", kv, customerId: this.query.customerId },
      });
    },
  },
};
</script>
